// Ulubieni zawodnicy (★) na /live — zapis tylko w tej przeglądarce, osobno dla każdego wydarzenia
// (jak w becie). Przeglądarka bywa bez dostępu do localStorage (tryb prywatny, zablokowane dane,
// podgląd) — wtedy lista działa do odświeżenia strony.
const PREFIX = 'sledz-results:favorites:'

export function loadFavorites(alias) {
  try {
    const raw = window.localStorage.getItem(PREFIX + alias)
    const list = raw ? JSON.parse(raw) : []
    return new Set(Array.isArray(list) ? list.map(String) : [])
  } catch (error) {
    return new Set()
  }
}

export function saveFavorites(alias, ids) {
  try {
    window.localStorage.setItem(PREFIX + alias, JSON.stringify([...ids]))
  } catch (error) {
    // brak zapisu — ulubieni zostają do odświeżenia strony
  }
}
